import { create } from "zustand";

const nutzungSubLayers = [
  "infrastruktur_verkehr",
  "bauwerke_anlagen",
  "gewaesser",
  "naturraeume_vegetation",
  "rohstoff_bergbau",
  "schutz_recht_festlegung",
  "siedlungs_und_nutzung",
];

export const useLayerStore = create((set) => ({
  visibleLayers: {
    topographie: false,
    flurstucke: true,
    gebaude: true,
    nutzung: false,
    infrastruktur_verkehr: false,
    bauwerke_anlagen: false,
    gewaesser: false,
    naturraeume_vegetation: false,
    schutz_recht_festlegung: false,
    siedlungs_und_nutzung: false,
    bauleitplane: false,
    riskGebiet: false,
  },

  toggleLayer: (layerId) =>
    set((state) => {
      const { visibleLayers } = state;

      if (layerId === "nutzung") {
        const newState = !visibleLayers.nutzung;

        const updated = {
          ...visibleLayers,
          nutzung: newState,
        };

        // If turning OFF → turn off all sublayers
        if (!newState) {
          nutzungSubLayers.forEach((sub) => (updated[sub] = false));
        }

        // If turning ON → keep sublayer visibility as is
        // (do NOT automatically turn them on)

        return { visibleLayers: updated };
      }

      if (nutzungSubLayers.includes(layerId)) {
        const currentlyOn = visibleLayers[layerId];
        const turningOn = !currentlyOn;

        const updated = { ...visibleLayers };

        if (turningOn) {
          // Turning ON → turn OFF all other siblings
          nutzungSubLayers.forEach((id) => (updated[id] = false));
          updated[layerId] = true;

          // Ensure nutzung is enabled
          updated.nutzung = true;
        } else {
          // Turning OFF → simply turn off this layer
          updated[layerId] = false;

          // If ALL sublayers are off → turn off nutzung
          const anyOn = nutzungSubLayers.some((id) => updated[id]);
          if (!anyOn) updated.nutzung = false;
        }

        return { visibleLayers: updated };
      }

      // --------------------------------------------
      // 3️⃣ DEFAULT FOR NON-NUTZUNG LAYERS
      // --------------------------------------------
      return {
        visibleLayers: {
          ...visibleLayers,
          [layerId]: !visibleLayers[layerId],
        },
      };
    }),
}));
